import React, { useEffect, useState } from "react";
import { FlowService } from "../../../service/FlowService";
import { Box, Typography, useTheme } from "@mui/material";
import {
  NotificationType,
  useNotificationStore,
} from "../../../store/storeNotifications";
import { getAPIErrorMessage } from "../../../helpers/helpers";
import LoadingSpinner from "../../../components/UI/LoadingSpinner";
import FlowsTable from "../../Dashboard/FlowsTable";

const RecentlyOpened: React.FC = () => {
  const setNotification = useNotificationStore(
    (state) => state.setNotification,
  );
  const [recentFlows, setRecentFlows] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);
  const theme = useTheme();
  const { semanticColors } = theme;

  useEffect(() => {
    const getRecentFlows = async () => {
      try {
        const { data } = await FlowService.lastSeen(1);

        setRecentFlows(data);
      } catch (error) {
        setNotification({
          type: NotificationType.Error,
          message: getAPIErrorMessage(error as any),
        });
      }
      setLoading(false);
    };

    getRecentFlows();
  }, [setNotification]);

  if (loading) return <LoadingSpinner />;

  if (!loading && recentFlows.length === 0)
    return (
      <Box
        sx={{
          border: `1px dashed ${semanticColors.borderDashed}`,
          width: "100%",
          height: "100%",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Typography
          sx={{
            color: semanticColors.textSecondary,
          }}
        >
          You don't have any recently opened files
        </Typography>
      </Box>
    );

  return (
    <Box sx={{ height: "100%", width: "100%" }}>
      <FlowsTable flows={recentFlows} maxRows={6} />
    </Box>
  );
};

export default RecentlyOpened;
